import { useMemo } from "react";

export default function TankGauge({ litres, capacity, low }) {
  const pct = Math.max(0, Math.min(100, (litres / capacity) * 100));
  // Color logic — Portside palette
  const color = low ? "#db0812" : pct < 30 ? "#e84e0f" : pct < 70 ? "#0088c2" : "#006f9e";
  const fillHeight = useMemo(() => `${pct.toFixed(2)}%`, [pct]);

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 card-lift" data-testid="tank-gauge">
      <div className="flex items-start justify-between mb-5">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-ps-blue font-semibold">Fuel reservoir</div>
          <div className="font-display font-extrabold text-2xl tracking-tight mt-1 text-ps-deep">40,000 L tank</div>
        </div>
        <div className={`px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] font-bold border rounded-md ${low ? "bg-red-50 text-red-700 border-red-300" : "bg-emerald-50 text-emerald-800 border-emerald-200"}`}>
          {low ? "Low stock" : "Operational"}
        </div>
      </div>

      <div className="flex gap-6 items-end">
        {/* Tank visual */}
        <div className="relative w-28 h-56 border-2 border-ps-deep rounded-md bg-slate-50 overflow-hidden">
          <div
            className="absolute bottom-0 left-0 right-0 transition-all duration-700"
            style={{ height: fillHeight, background: `linear-gradient(180deg, ${color} 0%, rgba(0,111,158,0.85) 100%)` }}
          >
            <div
              className="absolute -top-2 left-0 w-[200%] h-3 wave-animate opacity-70"
              style={{ background: `repeating-linear-gradient(90deg, ${color} 0 8px, rgba(255,255,255,0.45) 8px 16px)` }}
            />
          </div>
          {[25, 50, 75].map((m) => (
            <div key={m} className="absolute left-0 right-0 border-t border-dashed border-slate-300" style={{ bottom: `${m}%` }}>
              <span className="absolute -right-8 -top-2 text-[9px] font-mono-data text-slate-500">{m}%</span>
            </div>
          ))}
        </div>

        <div className="flex-1 grid grid-cols-2 gap-4">
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Current</div>
            <div className="font-display font-extrabold text-3xl tabular tracking-tight" style={{ color }}>{Math.round(litres).toLocaleString()}</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">litres</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Capacity</div>
            <div className="font-display font-extrabold text-3xl tabular tracking-tight text-ps-deep">{capacity.toLocaleString()}</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">litres</div>
          </div>
          <div className="col-span-2">
            <div className="flex items-baseline justify-between">
              <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Fill level</div>
              <div className="font-mono-data tabular text-lg text-ps-deep font-semibold">{pct.toFixed(1)}%</div>
            </div>
            <div className="h-2 bg-slate-200 rounded-full mt-2 overflow-hidden">
              <div className="h-full transition-all duration-700 rounded-full" style={{ width: fillHeight, background: color }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
